import { TabsStickyProps } from '@comfama/comfama-ui-react';

interface ITabsFlotanteProps extends TabsStickyProps {}

function tabsFlotanteAdapter(data: any): ITabsFlotanteProps {
    return {
        items: data.referenciaPlantillaContenido?.map((tab: any) => ({
            id: tab.tituloDescripcion ?? '',
            label: tab.tituloBanner ?? '',
        })),
    };
}
export default tabsFlotanteAdapter;
